"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _categoryApi = require("@/api/categoryApi");

var _systemSetting = require("@/api/systemSetting");

var _auth = require("@/utils/auth");

var _permission = require("@/utils/permission");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// 权限判断函数
var _default2 = {
  name: "Upload",
  props: {
    pictureType: {
      type: String,
      default: ""
    },
    isMore: {
      type: String,
      default: "1"
    },
    modelName: {
      type: String,
      default: ""
    },
    checkedMore: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      loadingPic: false,
      loading: false,
      modals: false,
      allTreeList: [],
      categoryProps: {
        value: "id",
        label: "name",
        children: "child",
        expandTrigger: "hover",
        checkStrictly: true,
        emitPath: false
      },
      editPram: {
        pid: 1000,
        name: "",
        type: 2,
        sort: 1,
        status: 0,
        url: "url",
        id: 0
      },
      visible: false,
      bizTitle: "",
      sleOptions: {
        attrId: "",
        pid: ""
      },
      list: [],
      grid: {
        xl: 7,
        lg: 7,
        md: 7,
        sm: 7,
        xs: 24
      },
      grid2: {
        xl: 17,
        lg: 17,
        md: 17,
        sm: 17,
        xs: 24
      },
      filterText: "",
      treeData: [],
      treeData2: [],
      defaultProps: {
        children: "child",
        label: "name"
      },
      tableData: {
        page: 1,
        limit: 10,
        pid: 0,
        attType: "jpg,jpeg,gif,png,bmp,PNG,JPG"
      },
      classifyId: 0,
      myHeaders: {
        "X-Token": (0, _auth.getToken)()
      },
      treeFrom: {
        status: -1,
        type: 2
      },
      pictrueList: {
        list: [],
        total: 0
      },
      isShowPic: false,
      checkPicList: [],
      ids: [],
      listPram: {
        pid: 0,
        type: 2,
        status: 0,
        name: "",
        page: 1,
        limit: 9999
      },
      localImg: "",
      videoStatus: false,
      typeDate: "pic"
    };
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  mounted: function mounted() {
    this.pictureType ? this.tableData.limit = 30 : this.tableData.limit = 10;
    if (this.$route && this.$route.query.field === "dialog") Promise.resolve().then(function () {
      return _interopRequireWildcard(require("./internal.js"));
    });
    this.getList();
    this.getFileList(); // this.handlerGetList()
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 选取图片后自动回调，里面可以获取到文件
    imgSaveToUrl: function imgSaveToUrl(event) {
      // 也可以用file
      this.localFile = event.raw; // 或者 this.localFile=file.raw
      // 转换操作可以不放到这个函数里面，
      // 因为这个函数会被多次触发，上传时触发，上传成功也触发

      var reader = new FileReader();
      reader.readAsDataURL(this.localFile); // 这里也可以直接写参数event.raw
      // 转换成功后的操作，reader.result即为转换后的DataURL ，
      // 它不需要自己定义，你可以console.integralLog(reader.result)看一下

      reader.onload = function () {// console.integralLog(reader.result)
      };
      /* 另外一种本地预览方法 */


      var URL = window.URL || window.webkitURL;
      this.localImg = URL.createObjectURL(event.raw); // 转换后的地址为 blob:http://xxx/7bf54338-74bb-47b9-9a7f-7a7093c716b5
    },
    closeModel: function closeModel() {
      this.$refs["editPram"].resetFields();
    },
    handlerSubmit: function handlerSubmit(formName) {
      var _this = this;

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this.editPram.pid == 10000) _this.editPram.pid = 0;
          _this.bizTitle === "添加分类" ? (0, _categoryApi.addCategroy)(_this.editPram).then(function (data) {
            _this.$message.success("创建成功");

            _this.visible = false;

            _this.getList();
          }) : (0, _categoryApi.updateCategroy)(_this.editPram).then(function (data) {
            _this.$message.success("编辑成功");

            _this.visible = false;

            _this.getList();
          });
        } else {
          return false;
        }
      });
    },
    // 表单分类
    handlerGetList: function handlerGetList() {
      var _this2 = this;

      var datas = {
        name: "全部图片",
        id: ""
      };
      (0, _categoryApi.treeCategroy)(this.treeFrom).then(function (data) {
        _this2.allTreeList = data;

        _this2.allTreeLis.unshift(datas);
      });
    },
    // 搜索分类
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 所有分类
    getList: function getList() {
      var _this3 = this;

      var data = {
        name: "全部图片",
        id: 10000
      };
      (0, _categoryApi.treeCategroy)(this.treeFrom).then(function (res) {
        _this3.treeData = res;

        _this3.treeData.unshift(data);

        _this3.treeData2 = _toConsumableArray(_this3.treeData);
      });
    },
    // 添加分类
    onAdd: function onAdd(id) {
      this.tableData.pid = id;
      if (this.tableData.pid === 10000) this.tableData.pid = 0;
      this.bizTitle = "添加分类";
      this.visible = true;
      if (id) this.editPram = {
        pid: id,
        name: "",
        type: 2,
        sort: 1,
        status: 0,
        url: "url",
        id: 0
      };
    },
    // 编辑
    onEdit: function onEdit(id) {
      var _this4 = this;

      if (id === 10000) id = 0;
      this.bizTitle = "编辑分类";
      this.loading = true;
      (0, _categoryApi.infoCategroy)({
        id: id
      }).then(function (res) {
        _this4.editPram = res;
        _this4.loading = false;
      });
      this.visible = true;
    },
    // 删除
    handleDelete: function handleDelete(id) {
      var _this5 = this;

      if (id === 10000) id = 0;
      this.$modalSure().then(function () {
        (0, _categoryApi.deleteCategroy)({
          id: id
        }).then(function () {
          _this5.$message.success("删除成功");

          _this5.getList();
        });
      });
    },
    handleNodeClick: function handleNodeClick(data) {
      this.checkPicList = [];
      this.tableData.pid = data.id;
      this.getFileList();
    },
    // 上传
    handleUploadForm: function handleUploadForm(param) {
      var _this6 = this;

      var formData = new FormData();
      var data = {
        model: this.modelName ? this.modelName : this.$route.path.split("/")[1],
        pid: this.tableData.pid
      };
      formData.append("multipart", param.file);
      var loading = this.$loading({
        lock: true,
        text: "上传中，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      (0, _systemSetting.fileImageApi)(formData, data).then(function (res) {
        loading.close();

        _this6.$message.success("上传成功");

        _this6.tableData.page = 1;

        _this6.getFileList();
      }).catch(function (res) {
        loading.close();
      });
    },
    // 文件列表
    getFileList: function getFileList() {
      var _this7 = this;

      if (this.tableData.pid === 10000) this.tableData.pid = 0;
      this.loadingPic = true;
      (0, _systemSetting.fileListApi)(this.tableData).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee(res) {
          return _index.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this7.pictrueList.list = res.list;
                  if (_this7.tableData.page === 1 && _this7.pictrueList.list.length > 0) _this7.pictrueList.list[0].localImg = _this7.localImg;

                  if (_this7.pictrueList.list.length) {
                    _this7.isShowPic = false;
                  } else {
                    _this7.isShowPic = true;
                  }

                  _this7.pictrueList.total = res.total;
                  _this7.loadingPic = false;

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function () {
        _this7.loadingPic = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableData.page = page;
      this.checkPicList = [];
      this.getFileList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableData.limit = val;
      this.getFileList();
    },
    // 选中图片
    changImage: function changImage(item, index, row) {
      var _this8 = this;

      var activeIndex = 0;

      if (!item.isSelect) {
        this.$set(item, "isSelect", true);
        this.checkPicList.push(item);
      } else {
        this.$set(item, "isSelect", !item.isSelect);
        this.checkPicList.map(function (el, index) {
          if (el.attId == item.attId) {
            activeIndex = index;
          }
        });
        this.checkPicList.splice(activeIndex, 1);
      }

      this.ids = [];
      this.checkPicList.map(function (item, i) {
        _this8.ids.push(item.attId);
      });
      this.pictrueList.list.map(function (el, i) {
        if (el.isSelect) {
          _this8.checkPicList.filter(function (el2, j) {
            if (el.attId == el2.attId) {
              el.num = j + 1;

              _this8.$nextTick(function () {
                _this8.pictrueList.list;
              });
            }
          });
        } else {
          el.num = 0;
        }
      });
    },
    // 点击使用选中图片
    checkPics: function checkPics() {
      if (!this.checkPicList.length) return this.$message.warning("请先选择图片");

      if (this.$route && this.$route.query.field === "dialog") {
        var str = "";

        for (var i = 0; i < this.checkPicList.length; i++) {
          str += '<img src="' + this.checkPicList[i].sattDir + '">';
        }
        /* eslint-disable */


        nowEditor.dialog.close(true);
        nowEditor.editor.setContent(str, true);
      } else {
        if (this.isMore === "1" && this.checkPicList.length > 1) {
          return this.$message.warning("最多只能选一张图片");
        }

        this.$emit("getImage", [].concat(_toConsumableArray(this.checkedMore), _toConsumableArray(this.checkPicList)));
      }
    },
    // 删除图片
    editPicList: function editPicList(tit) {
      var _this9 = this;

      if (!this.checkPicList.length) return this.$message.warning("请先选择图片");
      this.$modalSure().then(function () {
        (0, _systemSetting.fileDeleteApi)(_this9.ids.join(",")).then(function () {
          _this9.$message.success("刪除成功");

          _this9.getFileList();

          _this9.checkPicList = [];
        });
      });
    },
    // 移动分类点击
    handleSelClick: function handleSelClick(node) {
      if (this.ids.length) {
        this.sleOptions = {
          attrId: this.ids.join(","),
          pid: node.id
        };
        this.getMove();
      } else {
        this.$message.warning("请先选择图片");
      }
    },
    getMove: function getMove() {
      var _this10 = this;

      (0, _systemSetting.attachmentMoveApi)(this.sleOptions).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee2(res) {
          return _index.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this10.$message.success("操作成功");

                  _this10.clearBoth();

                  _this10.getFileList();

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this10.clearBoth();
      });
    },
    clearBoth: function clearBoth() {
      this.sleOptions = {
        attrId: "",
        pid: ""
      };
      this.checkPicList = [];
      this.ids = [];
    },
    videoChange: function videoChange(val) {
      if (val == false) {
        this.$set(this.tableData, "attType", "jpg,jpeg,gif,png,bmp,PNG,JPG");
        this.getFileList();
      } else {
        this.$set(this.tableData, "attType", "video/mp4");
        this.getFileList();
      }
    },
    radioChange: function radioChange(val) {
      if (val === 'video') {
        this.videoChange(true);
      } else {
        this.videoChange(false);
      }
    }
  }
};
exports.default = _default2;